import {ActivatedRoute, Router} from '@angular/router';
import {ProjectConstants} from './project-constants';
import { Platform } from '@ionic/angular';

export class BaseComponent extends ProjectConstants {
  baseRouter: Router;

  constructor(protected route: ActivatedRoute, protected router: Router) {
    super();
    this.baseRouter = router;
  }

  checkMobile(platform: Platform) {
    if (platform.width() <= 1000) {
      return true;
    } else {
      return false;
    }
  }

  resetSessionStorageFilters() {
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.CONTRACTUAL_VALUES_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.DISCOUNT_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.MINIMUM_COMMITMENT_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.DELTA_VOLUMES_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.SERVICE_CHANGES_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.CALCULATED_CHARGE_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.LOCAL_CUSTOMER_SETTINGS_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.CONTRACT_SETTING_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.ARCHITECTURE_STRUCTURE_SETTING_FILTER);
    sessionStorage.removeItem(this.SESSION_STORAGE_LABELS.CURRENCY_SETTING_FILTER);
  }
}
